export default __webpack_public_path__ + "static/logo-1ddcbf90d3670a836e99120322a9d429.svg";